import { useCallback, useEffect } from "react";
import Radio from "@/components/Radio";
import useBreakpoint from "@/hooks/useBreakpoint";
import { sendUserJourney } from "@/api/userJourney";
import { useFormStore } from "@/store/form";
import { useProductStore } from "@/store/product";
import { SetupByKeyFetch } from "@/api/setup";
import { useProvisionalLineSaleStore } from "@/store/provisionalLineSale";

type TypeProductProps = {
  typeProductSelected?: string;
  setTypeProductSelected(typeProduct: string): void;
};

const typeProducts = [
  { value: "MIGRACAO", label: "Já sou TIM" },
  { value: "NOVA_LINHA", label: "Quero uma nova linha" },
  {
    value: "PORTABILIDADE",
    label: "Quero trazer meu número de outra operadora para a TIM",
  },
];

const TypeProduct = ({
  typeProductSelected = "MIGRACAO",
  setTypeProductSelected,
}: TypeProductProps) => {
  const { data: setup } = SetupByKeyFetch("DDDS_PROVISIONAL_LINE");

  const { isOnBreakpoint: isTableOrLess } = useBreakpoint(1024);
  const classNames = "flex space-y-4 flex-col mb-8";
  const saleId = useFormStore((store) => store.saleId);
  const form = useFormStore((store) => store.value);
  const product = useProductStore((store) => store.item);
  const loyalty = useProductStore((store) => store.loyalty);
  const addData = useFormStore((store) => store.addData);
  const ddd = useFormStore((store) => store.value.tel).slice(0, 2);
  const setProvisionalLine = useProvisionalLineSaleStore(
    (store) => store.setProvisionalLine
  );

  const handleOnClickTypeProductUserJourney = useCallback(
    (value: string) => {
      addData({
        tipo: value,
      });
      sendUserJourney({
        ...form,
        product: product!,
        loyalty,
        ...{
          tipo: value,
          passo: "ESCOLHER_TIPO",
        },
      });
    },
    [addData, form, loyalty, product]
  );

  useEffect(() => {
    if (setup?.valor) {
      const areaCodeProvisionalLine = setup.valor.split(",");

      const checkIsProvisionalLineConfimation =
        areaCodeProvisionalLine.includes(ddd);

      if (typeProductSelected === "PORTABILIDADE") {
        setProvisionalLine(checkIsProvisionalLineConfimation ? 0 : 1);
      }
    }
  }, [ddd, setProvisionalLine, setup?.valor, typeProductSelected]);

  useEffect(() => {
    if (!form.tipo) {
      handleOnClickTypeProductUserJourney(typeProducts[0].value);
    }
  }, [form.tipo, handleOnClickTypeProductUserJourney]);

  const typeProductFiltered = typeProducts.filter((type) => {
    if (product?.tim_id === "1-QGZ69F") {
      if (type.value === "MIGRACAO") {
        return type;
      }

      return false;
    }

    return type;
  });

  return (
    <>
      <div className={classNames}>
        {typeProductFiltered.map((typeProduct) => (
          <Radio
            name="tipo"
            widthFull={isTableOrLess}
            disabled={!!saleId}
            id={typeProduct.value}
            key={typeProduct.value}
            value={typeProduct.value}
            checked={typeProductSelected === typeProduct.value}
            onClick={() => {
              setTypeProductSelected(typeProduct.value);
              handleOnClickTypeProductUserJourney(typeProduct.value);
            }}
            data-ic-section="sec-omega-tipo"
          >
            {typeProduct.label}
          </Radio>
        ))}
      </div>
    </>
  );
};

export default TypeProduct;
